import React, { useState, useEffect, useRef } from 'react';
import './style.scss';
import {Tooltip} from 'react-tooltip'

type tooltipProps = {
    triggerText : string | React.ReactNode;
    description : string;
};

export const SimpleTooltip = ({
  triggerText,
  description,
}: tooltipProps) => {
    return (
    <>
      <div data-tooltip-id="my-tooltip" data-tooltip-html={description.replace(/\n/g, '<br />')} className='tooltip-content'>
        {triggerText}
      </div>
      <Tooltip id="my-tooltip" className="simple-tooltip" place="top-start" openOnClick />
    </>
  );
};